export default __webpack_public_path__ + "static/media/it930-a033-5-en.a851fffe.jpg";